
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"6","height":"6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.492 5.93c-.49 0-.922-.11-1.297-.328a2.247 2.247 0 01-.86-.907 2.733 2.733 0 01-.296-1.28c0-.449.104-.863.313-1.243.213-.38.515-.682.906-.906.39-.224.83-.336 1.32-.336.474 0 .899.106 1.274.32.375.208.664.505.867.89.208.38.312.808.312 1.282s-.11.904-.328 1.289a2.246 2.246 0 01-.906.898c-.386.214-.82.32-1.305.32zm.04-4.063c-.443 0-.803.146-1.079.438-.276.286-.414.659-.414 1.117 0 .463.138.841.414 1.133.281.291.64.437 1.078.437.287 0 .545-.065.774-.195.229-.13.406-.315.53-.555a1.72 1.72 0 00.196-.82c0-.302-.065-.57-.195-.805a1.331 1.331 0 00-.531-.554 1.51 1.51 0 00-.774-.196z","fill":"currentColor"}})])
          )
        }
      }
    